import produce from 'immer';

// TYPES
import { toSelect } from 'utils/genericFunctions';
import { Types, ConsultarLocalidadesAssociada } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: ConsultarLocalidadesAssociada = {
	status: 0,
	data: null,
	enum: [],
};

export default function consultarLocalidadeReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarLocalidadesAssociada {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_LOCALIDADES_ASSOCIADA_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTAR_LOCALIDADES_ASSOCIADA_SUCCESS: {
				draft.enum = toSelect(action.payload.response.data, 'nome', 'id');
				draft.status = action.payload.response.status;
				draft.data = action.payload.response.data;
				break;
			}

			case Types.CONSULTAR_LOCALIDADES_ASSOCIADA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_LOCALIDADES_ASSOCIADA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
